import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

const IconNewPickupOrder = ({
  className,
  height,
  width,
  fill
}: IconInterface) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 100 100'
    fill={fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='0.5'
      y='0.5'
      width='99'
      height='99'
      rx='15.5'
      fill='white'
      stroke='#D6D6D6'
    />
    <path
      d='M39.8798 34.7872C40.5994 26.4491 43.8876 22.6784 50.0424 22.6784C56.1844 22.6784 59.4008 26.4309 59.9955 34.7579C60.0738 35.8539 61.0258 36.679 62.1218 36.6007C63.2179 36.5225 64.0429 35.5705 63.9647 34.4744C63.2331 24.2315 58.4911 18.6991 50.0424 18.6991C41.6067 18.6991 36.7983 24.2133 35.9153 34.4451C35.8208 35.5399 36.6317 36.5039 37.7265 36.5984C38.8213 36.6929 39.7854 35.882 39.8798 34.7872Z'
      fill='url(#paint0_linear_1646:9512)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M64.8593 32.5485C67.8144 32.5485 70.2849 34.7958 70.5639 37.7378L74.0047 74.0286C74.3034 77.1792 71.9915 79.9754 68.841 80.2741C68.6612 80.2911 68.4807 80.2997 68.3001 80.2997H31.6977C28.533 80.2997 25.9675 77.7342 25.9675 74.5695C25.9675 74.3728 25.9777 74.1762 25.9979 73.9805L29.7479 37.6897C30.0498 34.7686 32.5111 32.5485 35.4477 32.5485H64.8593ZM62.1117 36.5298C61.0128 36.5298 60.122 37.4206 60.122 38.5194C60.122 39.6183 61.0128 40.509 62.1117 40.509C63.2105 40.509 64.1013 39.6183 64.1013 38.5194C64.1013 37.4206 63.2105 36.5298 62.1117 36.5298ZM38.2415 36.5298C37.1426 36.5298 36.2518 37.4206 36.2518 38.5194C36.2518 39.6183 37.1426 40.509 38.2415 40.509C39.3403 40.509 40.2311 39.6183 40.2311 38.5194C40.2311 37.4206 39.3403 36.5298 38.2415 36.5298Z'
      fill='url(#paint1_linear_1646:9512)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_1646:9512'
        x1='35.7404'
        y1='30.6085'
        x2='91.2052'
        y2='42.6283'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#0A3040' />
        <stop offset='0.306028' stopColor='#062B58' />
        <stop offset='1' stopColor='#7F50E3' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_1646:9512'
        x1='35.7404'
        y1='30.6085'
        x2='91.2052'
        y2='42.6283'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#0A3040' />
        <stop offset='0.306028' stopColor='#062B58' />
        <stop offset='1' stopColor='#7F50E3' />
      </linearGradient>
    </defs>
  </svg>
)

export default Icon(IconNewPickupOrder)
